type Code = {
  [key: string]: string;
};

export const CodingCodes: Code = {
  serviceRequest: '11429006',
  laboratoryRequest: '15220000',
};
